import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import DangerBoxURL from 'components/1440p_Series_CGI_List/DangerBoxURL';
import { EuiSpacer } from '@elastic/eui';
import IntroCards from 'components/1440p_Series_CGI_List/Recording_Menu/recCGI';
import NavButtons from 'components/1440p_Series_CGI_List/NavButtons';
import * as React from 'react';
export default {
  BreadCrumbs,
  SEOHelmet,
  DangerBoxURL,
  EuiSpacer,
  IntroCards,
  NavButtons,
  React
};